export default "__VITE_ASSET__5f28b840__"